<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AppLayoutPrint',
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {
      return this.currentUser && this.currentUser.role.id === 'superadmin';
    },
    showEncargado() {
      return this.currentUser && this.currentUser.role.id === 'encargado';
    }
  },
  created() {
    if (!this.loggedIn) {
      this.$router.push("/auth/login");
    }
  }
}
</script>
